import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["value", "id", "type", "placeholder", "maxlength", "min", "max", "step"]

import { ref, useTemplateRef } from "vue";

// Input emiting a input event when unfocus, hiting return or optionally on a timeout (time without further change)

export default /*@__PURE__*/_defineComponent({
  __name: 'DelayedInput',
  props: {
    modelValue: {},
    inputstyle: {},
    delay: { default: 0 },
    validate: {},
    waitOnEmpty: { type: Boolean, default: true },
    id: {},
    type: { default: "text" },
    placeholder: {},
    maxlength: {},
    min: {},
    max: {},
    step: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const timeout = ref<ReturnType<typeof setTimeout> | null>(null);
const inputEl = useTemplateRef("inputEl");

const emit = __emit;

const update = () => {
	if (!inputEl.value) return;

	if (props.validate) inputEl.value.value = props.validate(inputEl.value.value);

	emit("update:modelValue", inputEl.value.value);
	inputEl.value.classList.remove("dirty");
	inputEl.value.classList.add("updated");
	clearTimeout(timeout.value!);
};

const modified = () => {
	if (!inputEl.value) return;

	inputEl.value.classList.add("dirty");
	inputEl.value.classList.remove("updated");
	//                    Avoid automatically validating & propagating changes when the input is empty
	if (props.delay > 0 && !(props.waitOnEmpty && inputEl.value.value === "")) {
		clearTimeout(timeout.value!);
		timeout.value = setTimeout(() => {
			update();
		}, 1000 * props.delay);
	}
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _withModifiers(update, ["prevent"])
  }, [
    _createElementVNode("input", {
      onChange: update,
      onInput: modified,
      value: __props.modelValue,
      id: __props.id,
      type: __props.type,
      placeholder: __props.placeholder,
      maxlength: __props.maxlength,
      min: __props.min,
      max: __props.max,
      step: __props.step,
      ref_key: "inputEl",
      ref: inputEl
    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_1)
  ], 32 /* NEED_HYDRATION */))
}
}

})